import { z } from 'zod';

import { ZodB2bSavingPlanCompartment } from '@Common/types/b2b/compartments';
import { ZodCombinedIdsString } from '@Common/types/bo/b2b/plans';
import { ZodUserPortfolioPosition } from '@Common/types/bo/users_portfolios';
import { buildZodBoListQueryParsed } from '@Common/types/bo/utils/build_zod_bo_list_query';
import { createZodArrayable } from '@Common/types/zod/zod-arrayable';
import { ZodNumberQuery } from '@Common/types/zod/zod-number-query';

export const ZodGetEmployeeSavingsPortfolioResponse = z.array(ZodUserPortfolioPosition);
export type GetEmployeeSavingsPortfolioResponse = z.TypeOf<
  typeof ZodGetEmployeeSavingsPortfolioResponse
>;

export const ZodGetEmployeeSavingsPortfolioFilters = z.object({
  saving_plan_id: ZodCombinedIdsString,
  employee_id: ZodNumberQuery,
  compartment: createZodArrayable(ZodB2bSavingPlanCompartment).optional(),
});

export const getB2bEmployeePortfolioSortColumns: (keyof GetEmployeeSavingsPortfolioResponse[number])[] =
  ['id'];

export const ZodGetEmployeeSavingsPortfolioQuery = buildZodBoListQueryParsed(
  ZodGetEmployeeSavingsPortfolioFilters,
  getB2bEmployeePortfolioSortColumns,
);

export type GetEmployeeSavingsPortfolioQuery = {
  filter: z.TypeOf<typeof ZodGetEmployeeSavingsPortfolioFilters>;
  range?: [number, number];
  sort?: [(typeof getB2bEmployeePortfolioSortColumns)[number], 'ASC' | 'DESC'];
};
